/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M2.0008 2.0425c0-1.128.8955-2.0425 2-2.0425H20.001c1.1045 0 2 .9145 2 2.0425v19.9149c0 1.1281-.8955 2.0426-2 2.0426h-16c-1.1046 0-2-.9145-2-2.0426V2.0425Zm1.5 15.6075v4.3074c0 .2821.224.5107.5.5107H20.001c.2761 0 .5-.2286.5-.5107V17.65h-17ZM20.501 6.4V12h-17V6.4h17Z"
    clipRule="evenodd"
  />,
  'MenuAccessLogsFilled'
);
